import { buildHealthCertificateSummary, buildPublicHealthCertificateSummary } from "./health";
import { normalizeCenterTopConfig } from "./centerTop";
import type { CameraConfig, DisplaySnapshot, PublicCameraConfig, PublicDisplaySnapshot } from "./types";

export function toPublicSnapshot(snapshot: DisplaySnapshot, now = new Date()): PublicDisplaySnapshot {
  return {
    ...snapshot,
    healthCertificates: buildPublicHealthCertificateSummary(snapshot.healthCertificates.rows, now),
    centerTop: normalizeCenterTopConfig(snapshot.centerTop),
    cameras: snapshot.cameras.map(toPublicCamera)
  };
}

export function toAdminSnapshot(snapshot: DisplaySnapshot, now = new Date()): PublicDisplaySnapshot {
  return {
    ...snapshot,
    healthCertificates: buildHealthCertificateSummary(snapshot.healthCertificates.rows, now),
    centerTop: normalizeCenterTopConfig(snapshot.centerTop),
    cameras: snapshot.cameras.map(toPublicCamera)
  };
}

export function toPublicCamera(camera: CameraConfig): PublicCameraConfig {
  return {
    id: camera.id,
    name: camera.name,
    slot: camera.slot
  };
}
